import api from "@/components/customAxios/Axios";
import { useEffect } from "react";
import { useToast } from "../toast";
import { useLoader } from "@/context/loaderContext";
import Photo from "@/assets/success2.webp";
import AssessmentSideBar from "../AssessmentSideBar";
import AssessmentPagesFooter from "../AssessmentPagesFooter";
const Success = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const sendMailOnCompletingAssessment = async () => {
		try {
			const beha = sessionStorage.getItem("question");
			const candidateId = beha ? JSON.parse(beha).candidate_id : "";
			setLoading(true);
			const response = await api.post("/send_assessment_completion_email", {
				candidate_id: candidateId,
			});
			if (response.status === 200) {
				localStorage.clear();
				sessionStorage.clear();
			}

			document.exitFullscreen();
		} catch (error: any) {
			// send error toast
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Failed to send mail",
				description: error.response?.data?.error || error.response?.data?.message,
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		sendMailOnCompletingAssessment();
	}, []);
	return (
		<>
			<AssessmentSideBar />

			<div className="w-full h-[80vh] flex justify-center items-center">
				<div className="bg-white border rounded-xl py-6 px-8 flex flex-col gap-y-5 justify-center max-w-2xl">
					<div className="mt-8 flex justify-center">
						<img
							src={Photo}
							alt="Success Illustration"
							className="w-72 h-72 object-contain"
						/>
					</div>
					<h3 className="text-5xl font-semibold text-center">
						Congratulations
					</h3>
					<p className="text-base text-center">
						Congratulations on finishing your assessment! The recruiter will
						review your responses and reach out to you shortly.{" "}
						<strong> you may now close the window </strong>
					</p>
					{/* <button
						className="bg-[#BDE4C3] py-3 px-5 text-[#438437] rounded-xl hover:scale-105 transition "
						onClick={() => {
							if (document.fullscreenElement) {
								document.exitFullscreen();
							}
						}}
					>
						Close
					</button> */}
				</div>
			</div>

			{/* <div className="flex flex-col min-h-[80vh] justify-center items-center  dark:bg-gray-900">
				<h2 className="text-center text-7xl font-semibold leading-snug font-heading  decoration-gray-700 dark:decoration-gray-300">
					Congratulations
				</h2>
				<div className="text-center mt-8 px-12 font-body">
					<p className="text-lg text-gray-700 dark:text-gray-300 mb-2">
						Thank you for completing the assessment. Please hold on while we
						process your results.
					</p>
					<p className="text-lg text-gray-700 dark:text-gray-300 font-medium">
						<strong>
							The window will close automatically. Do not close it manually.
						</strong>
					</p>
					<p className="text-lg text-gray-700 dark:text-gray-300 mt-2">
						We appreciate your patience!
					</p>
				</div>
				<div className="mt-8">
					<img
						src={Photo}
						alt="Success Illustration"
						className="w-72 h-72 object-contain"
					/>
				</div>
			</div> */}
			<AssessmentPagesFooter />
		</>
	);
};

export default Success;
